export class StringUtils {

    public static replaceUtils = (text: string) => {
        const chars = [
            {
                replace: /[áàâã]/g,
                to: 'a'
            },

            {
                replace: /[éèê]/g,
                to: 'e'
            },

            {
                replace: /[ç]/g,
                to: 'c'
            },

            {
                replace: /[íìîĩ]/g,
                to: 'i'
            },

            {
                replace: /[óòôõ]/g,
                to: 'o'
            },

            {
                replace: /[úùûũü]/g,
                to: 'u'
            },
        ];
        chars.forEach(item => text = text.replace(item.replace, item.to));
        return text.toLocaleLowerCase();
    }
}
